<template lang="pug">
  #app
    transition(name="fade")
      router-view
    notifications
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// Not_Logged_App.vue?4bf7fc0f